import Papa from 'papaparse'

// Convert the raw visualization API rows to a CSV string as-is.
// Arrays (e.g. recipientSalesIds) are flattened so Papa keeps them in one cell.
export const toCsv = (rows = []) => {
  const normalized = rows.map((row) =>
    Object.fromEntries(
      Object.entries(row).map(([key, value]) => [
        key,
        Array.isArray(value) ? value.join('; ') : value
      ])
    )
  )

  return Papa.unparse(normalized)
}
